import { createReducer } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';

import SignupStorage from '../../services/SignupStorage';
import { AuthStateType } from '../../types';
import {
  getProfileInfo,
  getUserList,
  loginUser,
  refreshToken,
  removeAuthData,
  setAuthLoading,
  setToken,
  setUserData,
  verifyLoginPhone,
} from '../actions/auth';
import { checkRegistrationStep, getStorageData } from '../actions/signup';

const account = JSON.parse(localStorage.getItem('account') || 'null');

export const initialState: AuthStateType = {
  loading: {
    login: false,
    getProfileInfo: false,
    getUserList: false,
    setUserAction: false,
    setUserRole: false,
    createUser: false,
    updateUser: false,
    changePassword: false,
  },
  account: account || {
    id: 0,
    token: '',
    uuid: '',
    phoneNumber: '',
    isLogedIn: false,
  },
  profile: {
    displayName: '',
    email: '',
    firstName: '',
    fullName: '',
    id: 0,
    lastName: '',
    logoLink: '',
    middleName: '',
    organizationId: 0,
    phoneNumber: '',
    position: '',
    role: 'VIEWER',
    status: 'ACTIVE',
    verified: false,
    introHints: [],
    repeatableHints: [],
  },
  userList: [],
};

const authReducer = createReducer(initialState, (builder) => {
  builder.addCase(loginUser.fulfilled, (state, action) => {});

  builder.addCase(verifyLoginPhone.fulfilled, (state, action) => {});

  builder.addCase(setAuthLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(setUserData, (state, action) => {
    state.account = action.payload.value;
    localStorage.setItem('account', JSON.stringify(action.payload?.value));
  });

  builder.addCase(setToken, (state, action) => {
    state.account.token = action.payload;
  });

  builder.addCase(checkRegistrationStep.fulfilled, (state, action) => {
    if (action.payload) {
      state.account.id = action.payload.id;
    }
  });

  builder.addCase(getStorageData, (state, action) => {
    const data = SignupStorage.getSignupStorage();
    if (data && data.token) {
      const decodedToken = jwtDecode<{ exp: number; iat: number }>(data.token);
      if (Date.now() < decodedToken.exp * 1000)
        state.account.token = data.token;
    }
  });

  builder.addCase(refreshToken.fulfilled, (state, action) => {
    if (action.payload) {
      state.account.token = action.payload.jwt;
      localStorage.setItem('account', JSON.stringify(state.account));
    }
  });

  builder.addCase(getProfileInfo.fulfilled, (state, action) => {
    if (action.payload) state.profile = action.payload;
  });

  builder.addCase(removeAuthData.fulfilled, () => initialState);

  builder.addCase(getUserList.fulfilled, (state, action) => {
    state.userList = action.payload;
  });
});

export default authReducer;
